import { createFileRoute } from "@tanstack/react-router";
import { ModuleIndexPage } from "@/routes/_auth/-module-index";

export const Route = createFileRoute("/_auth/dokumenty/")({
	component: ModuleIndexPage,
});
